import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import BreadcrumbNav, { createBreadcrumbItems, getDefaultBreadcrumbs } from './BreadcrumbNav';

const { Title, Text } = Typography;

const PageHeader = ({ 
  title, 
  subtitle, 
  breadcrumbs, 
  breadcrumb, // Accept both breadcrumb (singular) and breadcrumbs (plural)
  breadcrumbClickHandlers,
  showBackButton,
  onBack,
  rightContent,
  extra // Accept extra prop for backward compatibility
}) => {
  const navigate = useNavigate();
  
  // Use breadcrumb (singular) if provided, otherwise use breadcrumbs (plural)
  const finalBreadcrumbs = breadcrumb || breadcrumbs;
  
  // Determine which breadcrumbs to show
  const breadcrumbItems = finalBreadcrumbs 
    ? createBreadcrumbItems(finalBreadcrumbs, breadcrumbClickHandlers, navigate)
    : getDefaultBreadcrumbs(navigate);

  return (
    <div style={{ marginBottom: '24px' }}>
      {/* Breadcrumb */}
      <BreadcrumbNav 
        breadcrumbs={breadcrumbItems} 
        style={{ marginBottom: '16px' }}
      />
      
      {/* Title and Subtitle with optional right content */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Title level={3} style={{ margin: 0, marginBottom: '4px', fontSize: '24px', fontWeight: 600 }}>
            {title}
          </Title>
          {subtitle && (
            <Text type="secondary" style={{ fontSize: '14px' }}>
              {subtitle}
            </Text>
          )}
        </div>
        {(rightContent || extra) && (
          <div style={{ marginLeft: '24px' }}>
            {rightContent || extra}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
